<template>
  <div class="index-wrap">
    <div class="nav-container">
      <div class="left-name" @click="testclick">您好，{{userInfo.user.name || '***'}}医生！</div>
      <div :class="{'right-state':true, 'active': isNavActive}" @click="isNavActive=!isNavActive">
        <p>{{currentState == '1' || currentState=='defult' ? '在线' : '离线'}}</p>
        <img src="../assets/images/arrow_bottom_white.png" alt>
        <div class="switch-state">
          <div
            :class="{'state-item':true, 'active': currentState=='1' || currentState=='defult'}"
            @click.stop="switchState('1')"
          >在线</div>
          <div
            :class="{'state-item':true, 'active': currentState=='0'}"
            @click.stop="switchState('0')"
          >离线</div>
        </div>
      </div>
    </div>
    <div class="patient-container">
      <div class="item-wait">
        <div class="left-avatar">
          <img src="../assets/images/avatar_wait.png" alt>
        </div>
        <div class="right-content" @click="toWaitTreatPage()">
          <div class="left-name">待接诊</div>
          <div class="right-num arrow-right">{{total}}位</div>
        </div>
      </div>
      <div
        class="item-patient"
        @click="enterChat(session)"
        v-for="(session,i) in sessionlist"
        :key="i"
      >
        <div class="left-avatar" :class="{'red-hot': session.unread>0}">
          <img :src="session.avatar">
        </div>
        <div class="right-content">
          <div class="name-container">
            <div class="left-name">
              <p>{{session.name}}</p>
              <!-- <p
                class="special-text"
                v-if="patient.visitType === '1'"
              >{{patient.visitType === '0'?'初诊' : '复诊'}}</p> -->
              <!-- <p class="special-text">{{(patient.userSex === '2')?'女':'男'}} {{patient.userAge}}岁</p> -->
              <!-- <p class="special-text" v-if="(patient.consultType==='04'||patient.consultType==='03')">复诊</p> -->
            </div>
            <div class="right-time">{{session.updateTimeShow}}</div>
          </div>
          <div class="bottom-text">{{session.lastMsgShow}}</div>
          <!-- <rich-text :nodes="chattingHistory[patient.groupId] || ''" class="bottom-text"></rich-text> -->
        </div>
      </div>


      <!-- <div
        class="item-patient"
        @click="goChat(consult)"
        v-for="(consult,i) in consultList"
        :key="i"
      >
        <div class="left-avatar">

        </div>
        <div class="right-content">
          <div class="name-container">
            <div class="left-name">
              <p>{{consult.userName}}</p>
              <p
                class="special-text"
                v-if="patient.visitType === '1'"
              >{{patient.visitType === '0'?'初诊' : '复诊'}}</p>
              <p class="special-text">{{(patient.userSex === '2')?'女':'男'}} {{patient.userAge}}岁</p>
              <p class="special-text" v-if="(patient.consultType==='04'||patient.consultType==='03')">复诊</p>
            </div>
            <div class="right-time">{{session.updateTimeShow}}</div>
          </div>
          <div class="bottom-text">{{session.lastMsgShow}}</div>
          <rich-text :nodes="chattingHistory[patient.groupId] || ''" class="bottom-text"></rich-text>
        </div>
      </div> -->


    </div>
    <div class="bottom-border"></div>
  </div>
</template>


<script>
import cookie from 'js-cookie';
import { mapState, mapMutations, mapGetters } from 'vuex'
import util from '@/utils'

import * as $services from '@/services/index'

  export default {
    name: "imIndex",
    data() {
      return {
        isNavActive:false,
        currentState:'defult',
        total:0,
        consultList:[]
      }
    },
    computed: {
      ...mapGetters([
        "userInfo"
      ]),
      userInfos () {
        return this.$store.state.nimSDK.userInfos
      },
      myPhoneId () {
        return `${this.$store.state.nimSDK.userUID}`
      },
      currSessionId () {
        return this.$store.state.nimSDK.currSessionId
      },
      sessionlist:function() {
        let sessionlist = this.$store.state.nimSDK.sessionlist.filter(item => {
          item.name = ''
          item.avatar = ''
          if (item.scene === 'p2p') {
            let userInfo = null
            if (item.to !== this.myPhoneId) {
              userInfo = this.userInfos[item.to]
            } else {
              // userInfo = this.myInfo
              // userInfo.alias = '我的手机'
              // userInfo.avatar = `${config.myPhoneIcon}`
              return false
            }
            if (userInfo) {
              item.name = util.getFriendAlias(userInfo)
              item.avatar = userInfo.avatar
            }
          }
          let lastMsg = item.lastMsg || {}
          if (lastMsg.type === 'text') {
            item.lastMsgShow = lastMsg.text || ''
          } else if (lastMsg.type === 'custom') {
            item.lastMsgShow = util.parseCustomMsg(lastMsg)
          } else if (lastMsg.scene === 'team' && lastMsg.type === 'notification') {
            item.lastMsgShow = util.generateTeamSysmMsg(lastMsg)
          } else if (util.mapMsgType(lastMsg)) {
            item.lastMsgShow = `[${util.mapMsgType(lastMsg)}]`
          } else {
            item.lastMsgShow = ''
          }
          if (item.updateTime) {
            item.updateTimeShow = util.formatDate(item.updateTime, true)
          }
          return item
          // var count = this.dateCount(item.updateTime);
          // if(count < this.timeSel){
          //     return item
          // }else{
          //     return false
          // }
        })
        return sessionlist
      }
    },
    created:function(){
      //this.getUserInfo();
      // 提交sdk连接请求
      this.doctorInfo = JSON.parse(window.localStorage.getItem("doctorInfo"));
      // this.$store.dispatch('connect')
      // this.$store.dispatch('updateRefreshState')
      this.getConsultList();

    },
    mounted:function(){
      this.$store.dispatch('connect')
      // this.$store.dispatch('resetNoMoreHistoryMsgs');
      // this.loadMore();
    },
    methods: {
      testclick(){},
      switchState(val){

      },
      toWaitTreatPage(){

      },
      enterChat(session) {
        this.imSessionId = session.id;
        var custom = JSON.parse(session.lastMsg.custom);
        cookie.set("recordStatus","03");
        cookie.set("currSession",this.imSessionId);
        this.$store.dispatch('setRecordStatus', "03");
        this.$store.dispatch('setCurrSession', this.imSessionId);
        this.$router.push({path: "/imChat", query: {userType:"03",orderNo:custom.orderNo}});
      },
      getConsultList(){
        $services.getConsultList({}).then(res => {
          this.consultList = res;
        }).catch(function (err) {
          console.log(err);
        });
      },
      // goChat(consultInfo){
      //   cookie.set("consultInfo",consultInfo);
      //   this.$router.push({path: "/imChat", query: {}});
      // }

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/imIndex.vue